import React from "react"
import "./scss/App.scss"
import Family from "./components/Family"

function App() {
  return (
    <main className="App">
      <header className="App-header">
        <h1 className="text-center"><img src="images/banner.png" alt="The Nursery" /></h1>
      </header>
      <section>
        <Family />
      </section>
      <footer className="spiffy-footer">
        Coded with &hearts; by Bandit for The Apostles, with graphics by the amazing Wish<br/>
      </footer>
    </main>
  );
}

export default App;
